import React, { useEffect, useCallback } from 'react';
import Auth from '../../../utils/Auth';
import { withRouter } from 'react-router-dom';
import { resendState } from '../../../redux/userAuthentication/userAuth.actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import UserTypes from '../../../utils/userTypes';
import { persistor } from '../../../getStore.js';

const mapDispatchToProps = (dispatch) => {
	return {
		resendState: () => dispatch(resendState()),
	};
};

const mapStateToProps = (state) => {
	return {
		userType: state.rootReducer.loginDetails.userType,
	};
};
const Logout = ({ history, resendState, userType }) => {

	const apiUrl = "https://api.steptest.in/v1/logout";

	fetch(apiUrl, {
		method: "GET", // Adjust to the appropriate HTTP method (POST/GET/etc.)
		headers: {
			"Content-Type": "application/json", // Include if the API requires JSON payloads
			"access-token": localStorage.getItem('token')// Add the access-token in the header
		},
	})
	/*.then(response => {
	  if (response.ok) { 
		return response.json(); // Parse JSON if the response is successful
	  } else {
		console.log("Logout Failed");
	  }
	})
	.then(data => {
	  console.log("Logout successful:", data);
	  // Additional actions like redirecting the user can go here
	})
	.catch(error => {
	  console.error("Error during logout:", error);
	});*/

	const reset = useCallback(async () => {
		//await resendState();
		let redirectUrl = '/';
		if (userType === UserTypes.Junior) {
			redirectUrl = '/junior/signin';
		} else if (userType === UserTypes.Parent) {
			redirectUrl = '/parent/login';
		} else {
			redirectUrl = '/';
		}
		await persistor.purge().then(() => {
			return persistor.flush();
		});
		localStorage.clear();
		sessionStorage.clear();

		Auth.isAuthenticated = null;

		history.push(redirectUrl);
	}, [history, userType]);

	useEffect(() => {
		reset();
	}, [reset]);

	return <div></div>;
};
export default compose(
	withRouter,
	connect(mapStateToProps, mapDispatchToProps),
)(Logout);
